window.fetchNotifications = function () {

    $('.viewall-click').unbind();
    $('.viewall-click').click(function () {

        if ($(".notification-body").is(":visible")) {
            $(".notification-body").hide();
        } else {
            $(".notification-body").show();
            $.ajax({
                type: 'GET',
                headers: {
                    'X-CSRF-Token': $('input[name="_token"]').val()
                },
                url: '/condominio/notifications/view',
                success: function (data) {
                    $(this).parent().remove();
                }
            });
        }
    });
    $('.clearall-click').unbind();
    $('.clearall-click').click(function () {
        $.ajax({
            type: 'GET',
            headers: {
                'X-CSRF-Token': $('input[name="_token"]').val()
            },
            url: '/condominio/notifications/clearall',
            success: function (data) {
                $('#notification_badge').empty();
                $(".notification-body").hide();
            }
        });
    });

    $.ajax({
        type: 'GET',
        headers: {
            'X-CSRF-Token': $('input[name="_token"]').val()
        },
        url: '/condominio/notifications',
        success: function (data) {

            $('#notifications_body').empty();

            const resultData = data.data

            if (resultData && resultData.length > 0) {
                $('.clearall-click').show();
                let number_views = 0;
                resultData.forEach(function (item, index) {
                    let row = null;
                    if (item.read) {
                        row = '<p class="dropdown-item " style="justify-content:space-between"> <a class="text-decoration-none text-secondary"  href="/condominio/notifications/' + item.id + '"> <i class="fa fa-exclamation text-success" style="margin-right: 2px"></i> ' + item.message + ' </a> <i class="fa fa-trash text-danger p-2 trash-click" id=' + item.id + ' style="margin-right: 2px;cursor:pointer;" data-toggle="tooltip" data-placement="top" title="Deletar" ></i>  </p>';

                    } else {
                        row = '<p class="dropdown-item " style="justify-content:space-between"> <a class="text-decoration-none text-dark"  href="/condominio/notifications/' + item.id + '"> <i class="fa fa-exclamation text-success" style="margin-right: 2px"></i> ' + item.message + ' </a> <i  class="fa fa-trash text-danger p-2 trash-click" id=' + item.id + ' style="margin-right: 2px;cursor:pointer;" data-toggle="tooltip" data-placement="top" title="Deletar"></i> </p>';
                    }

                    if (!item.open) {
                        number_views = number_views + 1;
                    }


                    $('#notifications_body').append(row);
                })
                if (number_views > 0) {
                    $('#notification_badge').html(number_views);
                } else {
                    $('#notification_badge').html(null);
                }


                $(".trash-click").each(function () {
                    const botaodelete = $(this);
                    botaodelete.unbind();
                    botaodelete.click(function () {
                        //$(this).parent().remove();
                        $.ajax({
                            type: 'GET',
                            headers: {
                                'X-CSRF-Token': $('input[name="_token"]').val()
                            },
                            url: '/condominio/notifications/delete/' + $(this).prop("id"),
                            success: function (data) {
                                botaodelete.parent().remove();
                            }
                        });

                    })
                });




            } else {
                $('.clearall-click').hide();
                $('#notification_badge').empty();
            }
        }
    });
}


fetchNotifications();
